export default __webpack_public_path__ + "static/media/Paysend.34166c98.png";